// extracted by mini-css-extract-plugin
export default {"container":"IconWithValue_container__MulDQ","icon":"IconWithValue_icon__qUzC5","value":"IconWithValue_value__f1vuT","unit":"IconWithValue_unit__1yYuP"};